import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  OffsetCollectionConfig,
  useWixPatternsContainer,
  useCreateCollection,
} from '@wix/bex-core/react';
import { CardsGridState } from '../state';

/**
 * @deprecated use useGrid instead
 */
export function useOffsetGrid<T, F extends FiltersMap = OptionalFiltersMap>(
  config: OffsetCollectionConfig<T, F>,
) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new CardsGridState({
        collection: createCollection<T, F>({
          ...config,
          paginationMode: 'offset',
        }),
        container,
      }),
  );

  return state;
}
